import React from 'react'
import { Panel, Card } from '../../../_components'
import { useDispatch, useSelector } from 'react-redux'
import { setDisplayModal, removePurchaseItem } from '../../../_slices/AppSlice'
import { formatCurrency } from '../../../_utils'

export default function SectionA() {
  const dispatch = useDispatch()
  const state = useSelector( state => {
    return {
      title: state.application.displayModal?.title,
      flag: state.application.displayModal?.flag,
      purchaseTools: state.application.purchaseTools
    }
  } )

  const handleDeleteItem = async ( idx ) => {
    await dispatch( removePurchaseItem( { idx } ) )
  }

  const handleCalculateFooter = ( tag ) => {

    if( state[ tag ].length > 0 ) {
     return state[tag].filter( item => { 
        return parseFloat( item.qty ) > 0 && parseFloat( item.rate ) > 0 
      } )
      .map( val => parseFloat( val.amount ) )
      .reduce( ( acc, curr ) => {
        return acc + curr 
      }, 0 )
    }

  }

  return (
    <Card title="Inputs / Expenditure">
        <Panel label="Section A: Purchase of Tools">
        <button className="text-xs bg-blue-700 text-white px-2 py-1 my-2 rounded" type="button" onClick={() => dispatch( setDisplayModal( { flag: true, title: "Purchase of Tools" } ) )}>
            {`Add`}
        </button>
        <div className="grid grid-cols-1">
            <table className="w-full border">
              <thead className="text-xs bg-gray-200 font-bold p-2 uppercase">
                  <th>Actions</th>
                  <th className="p-2">#</th>
                  <th>{`Item`}</th>
                  <th>{`Quantity`}</th>
                  <th>{`Rate`}</th>
                  <th>{`Amount(UGX)`}</th>
              </thead>
              <tbody>
                  {state.purchaseTools.filter( item => parseFloat( item.qty ) > 0 ).map( ( val, index ) => {
                      return (
                          <tr className="text-xs p-2 text-center border border-gray-300">
                              <td className="p-2" onClick={ () => handleDeleteItem( index ) }>
                                <button className="rounded bg-red-500 px-2 text-white" type="button">
                                  {`Delete`}
                                </button>
                              </td>
                              <td>{`${index+1}`}</td>
                              <td>{val.item}</td>
                              <td>{val.qty}</td>
                              <td>{val.rate && formatCurrency( val.rate )}</td>
                              <td>{val.amount && formatCurrency( val.amount )}</td>
                          </tr>
                      )
                  } )}
              </tbody>
              <tfoot className="bg-gray-400 text-sm uppercase font-bold text-center">
                  <td></td>
                  <td>{`Total`}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{handleCalculateFooter("purchaseTools")}</td>
              </tfoot>
            </table>
        </div>
      </Panel>
    </Card>
  )
}
